// ACTION TYPES
export const GET_COUNTRIES = 'SMK_ADMIN/GET_COUNTRIES';
export const GET_REGIONS = 'SMK_ADMIN/GET_REGIONS';
export const GET_DISTRICTS = 'SMK_ADMIN/GET_DISTRICTS';
export const GET_CITIES = 'SMK_ADMIN/GET_CITIES';
export const GET_SUB_AREAS = 'SMK_ADMIN/GET_SUB_AREAS';
